import Grid from '@mui/material/Grid';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomTextField from '../../../../../components/CustomTextInput';
export interface parkinglistfieldProps {
    id: string;
    updateQuoteField: (index: number, name: string, value: any) => void;
    qty: number;
    kindOfPackage?: string;
    qtyOfPackage?: number;
    weightOfPackageKG?: string;
    grossWeightOfPackageKG?: string;
    measurementOfPackage?: string;
    index: number;
    removeQuoteField: (index: number) => void;
    item?: any;
}

const Parkinglistfield = ({
    id,
    updateQuoteField,
    qty,
    kindOfPackage,
    qtyOfPackage,
    weightOfPackageKG,
    grossWeightOfPackageKG,
    measurementOfPackage,
    index,
    removeQuoteField,
    item
}: parkinglistfieldProps) => {
    return (
        <div className='relative custom-quote-field'>
            <Grid container>
                <Grid item xs={12} md={12} lg={6}>
                    <div className='lg:border lg:border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1.1rem] lg:pb-4 lg:h-full'>
                        <Grid
                            container
                            spacing={3}
                            sx={{
                                marginTop: '0px'
                            }}
                        >
                            <Grid item xs={12} md={12} lg={4}>
                                <CustomTextField
                                    id={`quote-productCode-${id}`}
                                    label='Product Code'
                                    name='productCode'
                                    onChange={(e: any) => {
                                        updateQuoteField(
                                            index,
                                            'productCode',
                                            e.target.value
                                        );
                                    }}
                                    value={item?.productCode}
                                />
                            </Grid>

                            <Grid item xs={12} md={12} lg={5}>
                                <div className='mt-4 lg:mt-0'>
                                    <CustomTextField
                                        required
                                        id={`quote-desc-${id}`}
                                        label='Description of Goods'
                                        name='desc'
                                        onChange={(e: any) => {
                                            updateQuoteField(
                                                index,
                                                'desc',
                                                e.target.value
                                            );
                                        }}
                                        value={item.desc}
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={12} lg={3}>
                                <div className='mt-4 lg:mt-0'>
                                    <CustomTextField
                                        value={item.qty}
                                        id={`quote-qty-${id}`}
                                        label='Unit Qty'
                                        name='qty'
                                        onChange={(e: any) => {
                                            updateQuoteField(
                                                index,
                                                'qty',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>

                <Grid item xs={12} md={12} lg={6}>
                    <div className='lg:border lg:border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1.1rem] lg:pb-4'>
                        <Grid
                            container
                            spacing={3}
                            sx={{
                                marginTop: '0px'
                            }}
                        >
                            <Grid item xs={12} md={12} lg={6}>
                                <div className='mt-4 lg:mt-0'>
                                    <CustomTextField
                                        value={kindOfPackage}
                                        id={`quote-kindOfPackage-${id}`}
                                        label='Package Kind'
                                        name='kindOfPackage'
                                        onChange={(e: any) => {
                                            updateQuoteField(
                                                index,
                                                'kindOfPackage',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} md={12} lg={6}>
                                <div className='mt-4 lg:mt-0'>
                                    <CustomTextField
                                        id={`quote-qtyOfPackage-${id}`}
                                        label='Package Qty'
                                        name='qtyOfPackage'
                                        value={qtyOfPackage}
                                        onChange={(e: any) => {
                                            updateQuoteField(
                                                index,
                                                'qtyOfPackage',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={12} lg={6}>
                                <div className='mt-4 '>
                                    <CustomTextField
                                        id={`quote-weightOfPackageKG-${id}`}
                                        label='Net Weight of Package (Kg)'
                                        name='weightOfPackageKG'
                                        value={weightOfPackageKG}
                                        onChange={(e: any) => {
                                            updateQuoteField(
                                                index,
                                                'weightOfPackageKG',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={12} lg={6}>
                                <div className='mt-4 '>
                                    <CustomTextField
                                        id={`quote-grossWeightOfPackageKG-${id}`}
                                        label='Gross Weight of Package (Kg)'
                                        name='grossWeightOfPackageKG'
                                        value={grossWeightOfPackageKG}
                                        onChange={(e: any) => {
                                            updateQuoteField(
                                                index,
                                                'grossWeightOfPackageKG',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={12} lg={6}>
                                <div className='mt-4 '>
                                    <CustomTextField
                                        id={`quote-measurementOfPackage-${id}`}
                                        label='Measurements of Package (m3)'
                                        name='measurementOfPackage'
                                        value={measurementOfPackage}
                                        onChange={(e: any) => {
                                            updateQuoteField(
                                                index,
                                                'measurementOfPackage',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>

            {index !== 0 && (
                <div
                    className='absolute top-[1.5rem] cursor-pointer right-[0.8rem] custom-quote-field-delete w-fit transition-all delay-75'
                    onClick={() => {
                        removeQuoteField(index);
                    }}
                >
                    <DeleteIcon />
                </div>
            )}

            <div className='border border-gray300 border-dashed mt-4 lg:mt-0 lg:border-none' />
        </div>
    );
};

export default Parkinglistfield;
